import React, {Component} from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import './header.scss'

class OnBoardingTitle extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            quote: null,
            proposal: null,
        }
    }

    componentDidMount() {
    }


    render() {
        return(
            <h6 className="font-weight-normal pl-1 my-0">
                <span className={""}>
                    <FormattedMessage
                        id="on_boarding.title.welcome_aboard_label"
                        defaultMessage="Welcome to QuoteMachine!"
                    />
                </span>
            </h6>
        );
    }
}

export default injectIntl(OnBoardingTitle)


// WEBPACK FOOTER //
// ./src/common/layout/onboardingtitle.component.jsx